import { render, staticRenderFns } from "./RecheckPassword.vue?vue&type=template&id=5d985bda&"
import script from "./RecheckPassword.vue?vue&type=script&lang=js&"
export * from "./RecheckPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports